import { Suspense, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { MainLayout } from '@/components/Layout';
// import appCompoLoading from '@/assets/animation/loading.json';
import { Users } from '@/features/users';
import { Locations } from '@/features/location';
import { Login } from '@/features/auth';
import appLoading from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import { useAuth } from '@/lib/auth';
import { PrivacyPolicy } from '@/features/privacyPolicy';
import { Contacts } from '@/features/contact';
import { Institutes } from '@/features/institute';
import { Products } from '@/features/product';
import {  Funnels } from '@/features/funnel';
import { Quote } from '@/features/quote';
import { Claim } from '@/features/Claim';
import TYPES from '@/utils/constants';

const App = () => {
  const { user } = useAuth();
  return (
    <MainLayout>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center root">
              <Lottie className="loading-loader-class" animationData={appLoading} />
          </div>
        }
      >
        {user?.userRoleId === TYPES.SUPER_ADMIN.toString() ? (
          <Routes>
             <Route path="/" element={<Funnels />} />
             <Route path="/users" element={<Users />} />
             <Route path="/location" element={<Locations />} />
             <Route path="/contacts" element={<Contacts />} />
             <Route path="/institutes" element={<Institutes />} />
             <Route path="/products" element={<Products />} />
             <Route path="/funnel" element={<Funnels />} />
          </Routes>
        ) :


        user?.userRoleId ===  TYPES.MARKETING.toString() ? (
          <Routes>
             <Route path="/" element={<Quote />} />
             <Route path="/quotes" element={<Quote />} />
             <Route path="/contacts" element={<Contacts />} />
             <Route path="/institutes" element={<Institutes />} />
             <Route path="/funnel" element={<Funnels />} />
          </Routes>
        ) :
        user?.userRoleId === TYPES.ACCOUNTS.toString() ? (
          <Routes>
             <Route path="/" element={<Claim />} />
             <Route path="/claim" element={<Claim />} />
          </Routes>
        ) 
      
        // : user?.userRoleId === '2' ? (
        //   <Routes>
        //      <Route path="/" element={<Users />} />
        //      <Route path="/users" element={<Users />} />
        //      <Route path="/location" element={<Locations />} />
        //      <Route path="/contacts" element={<Contacts />} />
        //      <Route path="/institutes" element={<Institutes />} />
        //      <Route path="/products" element={<Products />} />
        //   </Routes>
        // )
         : (
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        )}
      </Suspense>
    </MainLayout>
  );
};
export const protectedRoutes = [
  {
    path: '/*',
    element: <App />,
  },
];
